import React from 'react';
import EntityPropsUpdater from 'component/EntityPropsUpdater';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { addNotification } from 'actions/NotificationsActions';
import { Button, Col, Row } from 'react-bootstrap';
import Axios from 'axios';
import { confirmAlert } from 'react-confirm-alert';
import FormInput from 'components/forms/FormInput';
import LoaderCC from '../LoaderCC';

class LeadChangeAddressData extends EntityPropsUpdater {
  constructor(props) {
    super(props);
    this.state = {
      printing: false,
      disabledSendInvoiceEmail: '',
      disabledInvoiceAddress: 'disabled',
      disabledShippingAddress: 'disabled',
      email: '',
      loadAddresses: false,
    };
  }

  componentDidMount = () => {
    const { orderId } = this.props;
    this.changingShippingAddressAllowed(orderId);
    this.changingInvoiceAddressAllowed(orderId);
  };

  changeInvoiceAddress = (name, value) => {
    if (name === 'email') {
      this.setState({ email: value });
    }

    this.updateEntity(name, value, ['orders', 0, 'invoiceAddress', 'addressData']);
    this.updateEntity('changed', 'order');
  };

  changeShippingAddress = (name, value) => {
    this.updateEntity(name, value, ['orders', 0, 'shippingAddress', 'addressData']);
    this.updateEntity('changed', 'order');
  };

  sendInvoiceEmail = (orderId, emailState, emailDB) => {
    this.setState({ printing: 'sendInvoiceEmail' });
    if (emailState === '') {
      this.sendInvoiceReady(orderId, emailDB);
    } else {
      this.sendInvoiceReady(orderId, emailState);
    }
  };

  sendInvoiceReady = (orderId, email) => {
    const {
      intl: { messages },
    } = this.props;
    Axios.put('/api/orders/' + orderId + '/resendinvoice/' + email + '.json', {})
      .then(() => {
        this.setState({ printing: '' }, () => {
          const options = {
            customUI: ({ onClose }) => {
              return (
                <div className="react-confirm-alert-body">
                  <h1>{messages.send_invoice}</h1>
                  <p>
                    {messages.sended_invoice} {email}{' '}
                  </p>
                  <div className="react-confirm-alert-button-group" style={{ width: '100%', margin: '0 auto' }}>
                    <Button
                      style={{ margin: '0 auto', marginTop: '20px', width: '100px' }}
                      bsStyle="info"
                      onClick={onClose}
                    >
                      OK
                    </Button>
                  </div>
                </div>
              );
            },
            childrenElement: () => <div />,
            closeOnEscape: true,
            closeOnClickOutside: true,
          };
          confirmAlert(options);
        });
      })
      .catch(() => {
        this.setState({ message: 'Could not send invoice!' });
      });
  };

  changingInvoiceAddressAllowed = orderId => {
    this.setState({ loadAddresses: false });
    Axios.get('/api/orderallowchange/' + orderId + '/invoiceaddress.json', {}).then(response => {
      if (response.data === true) this.setState({ disabledInvoiceAddress: '' }, () => {});
    });
  };

  changingShippingAddressAllowed = orderId => {
    Axios.get('/api/orderallowchange/' + orderId + '/shippingaddress.json', {}).then(response => {
      if (response.data === true) this.setState({ disabledShippingAddress: '' }, () => {});
    });
  };
  /*
  test = () => {
  return false;
  }

*/

  render() {
    const {
      intl: { messages },
      entity,
      entityLoaded,
    } = this.props;

    const { printing, disabledSendInvoiceEmail, disabledInvoiceAddress, disabledShippingAddress, email } = this.state;

    if (!entityLoaded) {
      return <LoaderCC />;
    }

    const output = [];

    if (!entity.getOrders().length) {
      output.push(<p>n. A.</p>);
    } else {
      const orders = entity.getOrders()[0]; // so richtig sauber ist das nicht

      /*
        if(this.test() === false)
        {
          console.log("testisfalse");
        }
      */

      output.push(
        <div className="panel panel-transparent">
          <Row>
            <Col md={12}>
              <h3>{messages.change_of_address}</h3>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <div>
                <h4>{messages.invoice_address}</h4>
              </div>
              <div className="form-group form-group-default p-t-10 p-b-10">
                <Col md={12}>
                  <FormInput
                    type="text"
                    label={messages.company}
                    name="company"
                    onChange={this.changeInvoiceAddress}
                    value={orders.invoiceAddress.addressData.company}
                    disabled={disabledInvoiceAddress}
                  />
                </Col>

                <Col md={6}>
                  <FormInput
                    type="text"
                    label={messages.first_name}
                    name="firstName"
                    onChange={this.changeInvoiceAddress}
                    value={orders.invoiceAddress.addressData.firstName}
                    disabled={disabledInvoiceAddress}
                  />
                </Col>
                <Col md={6}>
                  <FormInput
                    type="text"
                    label={messages.last_name}
                    name="lastName"
                    onChange={this.changeInvoiceAddress}
                    value={orders.invoiceAddress.addressData.lastName}
                    disabled={disabledInvoiceAddress}
                  />
                </Col>

                <Col md={6}>
                  <FormInput
                    type="text"
                    label={messages.street}
                    name="street"
                    onChange={this.changeInvoiceAddress}
                    value={orders.invoiceAddress.addressData.street}
                    disabled={disabledInvoiceAddress}
                  />
                </Col>
                <Col md={6}>
                  <FormInput
                    type="text"
                    label={messages.house_number}
                    name="houseNumber"
                    onChange={this.changeInvoiceAddress}
                    value={orders.invoiceAddress.addressData.houseNumber}
                    disabled={disabledInvoiceAddress}
                  />
                </Col>
                <Col md={12}>
                  <FormInput
                    type="text"
                    label={messages.apartment_number}
                    name="apartmentNumber"
                    onChange={this.changeInvoiceAddress}
                    value={orders.invoiceAddress.addressData.apartmentNumber}
                    disabled={disabledInvoiceAddress}
                  />
                </Col>
                <Col md={12}>
                  <FormInput
                    type="text"
                    label={messages.address_line2}
                    name="addressLine2"
                    onChange={this.changeInvoiceAddress}
                    value={orders.invoiceAddress.addressData.addressLine2}
                    disabled={disabledInvoiceAddress}
                  />
                </Col>

                <Col md={6}>
                  <FormInput
                    type="text"
                    label={messages.zip_code}
                    name="zipCode"
                    onChange={this.changeInvoiceAddress}
                    value={orders.invoiceAddress.addressData.zipCode}
                    disabled={disabledInvoiceAddress}
                  />
                </Col>
                <Col md={6}>
                  <FormInput
                    type="text"
                    label={messages.city}
                    name="city"
                    onChange={this.changeInvoiceAddress}
                    value={orders.invoiceAddress.addressData.city}
                    disabled={disabledInvoiceAddress}
                  />
                </Col>

                <Col md={12}>
                  <FormInput
                    type="text"
                    label={messages.country}
                    name="countryName"
                    onChange={this.changeInvoiceAddress}
                    value={orders.invoiceAddress.addressData.countryName}
                    disabled={disabledInvoiceAddress}
                  />
                </Col>

                <Col md={12}>
                  <FormInput
                    type="text"
                    label={messages.email}
                    name="email"
                    onChange={this.changeInvoiceAddress}
                    value={orders.invoiceAddress.addressData.email}
                  />
                </Col>
                <p />
                <Col md={12}>
                  <Button
                    onClick={() =>
                      this.sendInvoiceEmail(orders.getId(), email, orders.invoiceAddress.addressData.email)
                    }
                    disabled={disabledSendInvoiceEmail}
                  >
                    {printing === 'sendInvoiceEmail' ? (
                      <i className="far fa-spin fa-spinner-third" />
                    ) : (
                      <i className="fas fa-file-invoice-dollar" />
                    )}{' '}
                    Rechnung senden
                  </Button>
                </Col>
              </div>
            </Col>
            <Col md={6}>
              <div>
                <h4>{messages.shipping_address}</h4>
              </div>
              <div className="form-group form-group-default p-t-10 p-b-10">
                <Col md={12}>
                  <FormInput
                    type="text"
                    label={messages.company}
                    name="company"
                    onChange={this.changeShippingAddress}
                    value={orders.shippingAddress.addressData.company}
                    disabled={disabledShippingAddress}
                  />
                </Col>

                <Col md={6}>
                  <FormInput
                    type="text"
                    label={messages.first_name}
                    name="firstName"
                    onChange={this.changeShippingAddress}
                    value={orders.shippingAddress.addressData.firstName}
                    disabled={disabledShippingAddress}
                  />
                </Col>
                <Col md={6}>
                  <FormInput
                    type="text"
                    label={messages.last_name}
                    name="lastName"
                    onChange={this.changeShippingAddress}
                    value={orders.shippingAddress.addressData.lastName}
                    disabled={disabledShippingAddress}
                  />
                </Col>

                <Col md={6}>
                  <FormInput
                    type="text"
                    label={messages.street}
                    name="street"
                    onChange={this.changeShippingAddress}
                    value={orders.shippingAddress.addressData.street}
                    disabled={disabledShippingAddress}
                  />
                </Col>
                <Col md={6}>
                  <FormInput
                    type="text"
                    label={messages.house_number}
                    name="houseNumber"
                    onChange={this.changeShippingAddress}
                    value={orders.shippingAddress.addressData.houseNumber}
                    disabled={disabledShippingAddress}
                  />
                </Col>
                <Col md={12}>
                  <FormInput
                    type="text"
                    label={messages.apartment_number}
                    name="apartmentNumber"
                    onChange={this.changeShippingAddress}
                    value={orders.shippingAddress.addressData.apartmentNumber}
                    disabled={disabledShippingAddress}
                  />
                </Col>

                <Col md={6}>
                  <FormInput
                    type="text"
                    label={messages.zip_code}
                    name="zipCode"
                    onChange={this.changeShippingAddress}
                    value={orders.shippingAddress.addressData.zipCode}
                    disabled={disabledShippingAddress}
                  />
                </Col>
                <Col md={6}>
                  <FormInput
                    type="text"
                    label={messages.city}
                    name="city"
                    onChange={this.changeShippingAddress}
                    value={orders.shippingAddress.addressData.city}
                    disabled={disabledShippingAddress}
                  />
                </Col>

                <Col md={12}>
                  <FormInput
                    type="text"
                    label={messages.country}
                    name="countryName"
                    onChange={this.changeShippingAddress}
                    value={orders.shippingAddress.addressData.countryName}
                    disabled={disabledShippingAddress}
                  />
                </Col>

                <Col md={12}>
                  <FormInput
                    type="text"
                    label={messages.email}
                    name="email"
                    onChange={this.changeShippingAddress}
                    value={orders.shippingAddress.addressData.email}
                    disabled={disabledShippingAddress}
                  />
                </Col>
              </div>
            </Col>
          </Row>
        </div>
      );
    }
    return <div className="clearfix padding-25 sm-padding-10">{output}</div>;
  }
}

const mapStateToProps = state => {
  return {
    user: state.login.user,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LeadChangeAddressData)
);
